import React from "react";
import { Container } from "reactstrap";
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";
import TourItem from "../components/UI/TourItem";
import tourData from "../assets/data/tourData";
import ToursOverview from '../components/UI/TourOverview';

const Tours = () => {
  return (
    <Helmet title="Tours">
      <CommonSection title="Tours" />

      <section>
        <Container>
          <ToursOverview>
        {tourData.map((item) => (
              <TourItem item={item} key={item.id} />
            ))}
            </ToursOverview>
        </Container>
      </section>
    </Helmet>
  );
};

export default Tours;
